// extracted by mini-css-extract-plugin
module.exports = {"container":"Categories_container__199cC","todos":"Categories_todos__c_Ep-","containerCategories":"Categories_containerCategories__2iDnt","iconT":"Categories_iconT__vpSDL"};